<template lang="pug">
    div
        // Button(@click="prettifyCode") Prettify
        // pre {{ cmOptions }}
        codemirror(
            ref="myCm"
            :value="codemirrorvalue"
            :options="cmOptions"
            @ready="onCmReady"
            @focus="onCmFocus"
            @input="onCmCodeChange"
            @inputRead="onInputRead"
            @keyHandled="onKeyHandled"
        )
            // v-model="code" 
</template>
<script>
import prettier from "prettier-standalone";
// const prettier = require("prettier/standalone");
import { codemirror } from "vue-codemirror";
// require styles
import "codemirror/lib/codemirror.css";

// language js
import "codemirror/mode/javascript/javascript.js";

// theme css
// import "codemirror/theme/monokai.css";
// import "codemirror/theme/tomorrow-night-eighties.css";
// import "codemirror/theme/moxer.css";
import "codemirror/theme/shadowfox.css";

// hint
import "codemirror/addon/hint/show-hint.css";
import "codemirror/addon/hint/show-hint.js";
import "codemirror/addon/hint/javascript-hint.js";

// active-line
import "codemirror/addon/selection/active-line.js";

import "codemirror/addon/selection/mark-selection.js";

import "codemirror/addon/scroll/annotatescrollbar.js";
import "codemirror/addon/search/matchesonscrollbar.js";
// import "codemirror/addon/search/match-highlither.js";
import "codemirror/addon/scroll/annotatescrollbar.js";
import "codemirror/addon/search/matchesonscrollbar.js";
import "codemirror/addon/search/match-highlighter.js";

// keyMap
import "codemirror/addon/edit/matchbrackets.js";
import "codemirror/addon/edit/closebrackets.js";
import "codemirror/addon/comment/comment.js";
import "codemirror/addon/dialog/dialog.js";
import "codemirror/addon/dialog/dialog.css";
import "codemirror/addon/search/searchcursor.js";
import "codemirror/addon/search/search.js";
import "codemirror/keymap/sublime.js";
import "codemirror/keymap/vim.js";

// foldGutter
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/addon/fold/brace-fold.js";
import "codemirror/addon/fold/comment-fold.js";
import "codemirror/addon/fold/foldcode.js";
import "codemirror/addon/fold/foldgutter.js";
import "codemirror/addon/fold/indent-fold.js";
import "codemirror/addon/fold/markdown-fold.js";
import "codemirror/addon/fold/xml-fold.js";

export default {
    name: "CodeEditorV2",
    // props: {
    // defaultCode: { type: String, default: "" },
    // },
    // props: ["formItem", "formData", "value", "cmOptionsInternal", "autoCompleteList"],
    props: {
        formItem: { type: Object, default: () => ({ mode: "text/javascript" }) },
        formData: { type: Object, default: () => ({}) },
        value: { type: String, default: "" },
        cmOptionsInternal: { type: Object, default: () => ({}) },
        autoCompleteList: { type: Array, default: () => [] },
    },
    components: {
        codemirror,
    },
    data() {
        return {
            // code: "",
            cmOptions: {
                // codemirror options
                tabSize: 4,
                styleActiveLine: true,
                lineNumbers: true,
                styleSelectedText: false,
                line: true,
                foldGutter: true,
                gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
                highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
                mode: "text/javascript",
                // mode: this.formItem.mode,

                // 只剩一個提示選項的時候自動選中選項
                hintOptions: {
                    completeSingle: false,
                },
                // keymap: "vim",
                keymap: "sublime",
                matchBrackets: true,
                autoCloseBrackets: true,
                showCursorWhenSelecting: true,
                // theme: "base16-dark",
                // theme: "moxer",
                theme: "shadowfox",
                extraKeys: this.formItem.extraKeys || {},
                // extraKeys: {
                //     Ctrl: "autocomplete",
                //     // Ctrl: function autoFormat(editor) {
                //     //     var totalLines = editor.lineCount();
                //     //     console.log(totalLines);
                //     //     // editor.autoFormatRange({ line: 0, ch: 0 }, { line: totalLines });
                //     // },
                // },
                smartIndent: true,
                showHint: true,
                autoCloseTags: true,
                autoComplete: true,
            },
        };
    },
    async mounted() {
        this.cmOptions = Object.assign(this.cmOptions, this.cmOptionsInternal);
        // this.code = this.formItem.defaultVal;
        // console.log("this is current codemirror object", this.codemirror);
        // var self = this;
        // setTimeout(() => {
        //     self.styleSelectedText = true;
        //     self.cmOptions.styleActiveLine = true;
        //     console.log("Style Selected Text Activate");
        // }, 1800);
        // let res = prettier.format("const a=  1", {
        //     // parser: "graphql",
        //     // plugins: prettierPlugins,
        // });
        // console.log(res);
    },
    directives: {},
    methods: {
        onCmReady(cm) {
            // console.log("the editor is readied!", cm);
            cm.setSize(null, 400);
        },
        onCmFocus(cm) {
            // console.log("the editor is focus!", cm);
        },
        onCmCodeChange(newCode) {
            // console.log("this is new code", newCode);
            // this.code = newCode;
            this.$emit("input", newCode);
            if (this.formItem && typeof this.formItem.watchField === "function") {
                this.formItem.watchField(newCode, this.formData);
            }
        },
        onInputRead(cm) {
            // let cursor = this.codemirror.getDoc().getCursor();
            // console.log(cursor);
            // let lineText = this.codemirror.getLine(cursor.line);
            // console.log(lineText);

            // 因為輸入時已經多走了一個游標
            var currentLine = this.codemirror.getCursor().line;
            var currentCursor = this.codemirror.getCursor().ch - 1;

            var currentWordStart = this.codemirror.findWordAt({ line: currentLine, ch: currentCursor }).anchor.ch;
            var currentWordEnd = this.codemirror.findWordAt({ line: currentLine, ch: currentCursor }).head.ch;
            // console.log(currentWordStart, currentCursor, currentWordEnd);
            // console.log(lineText[currentWordStart], lineText[currentCursor], lineText[currentWordEnd]);

            // console.log(
            //     this.codemirror.getRange(
            //         { line: currentLine, ch: currentWordStart },
            //         { line: currentLine, ch: currentWordEnd }
            //     )
            // );
            const currentWordBeforeCursor = this.codemirror.getRange(
                { line: currentLine, ch: currentWordStart },
                { line: currentLine, ch: currentCursor + 1 }
            );
            console.log(currentWordBeforeCursor);
            console.log(this.autoCompleteList.filter((e) => e.startsWith(currentWordBeforeCursor)));

            // const autoCompleteList = ["firefox", "fireball", "overfoo", "foxsay"];
            // const autoCompleteList = this.formItem.autoCompleteList || [];
            var self = this;
            this.codemirror.showHint({
                hint: function () {
                    return {
                        // from: self.codemirror.getDoc().getCursor(),
                        // // to: self.codemirror.getDoc().getCursor(),
                        // list: ["foo", "bar"],
                        from: { line: currentLine, ch: currentWordStart },
                        to: { line: currentLine, ch: currentWordEnd },
                        list: self.autoCompleteList.filter((e) => e.startsWith(currentWordBeforeCursor)),
                    };
                },
            });
            // console.log(cm);
            //     if (cm.state.completionActive)
            // console.log(cm.state.completionActive);
        },
        onKeyHandled(cm) {
            // console.log("onKeyHandled");
        },
        prettifyCode() {
            try {
                let prettifyResult = prettier.format(this.value, { tabWidth: 4 });
                this.codemirror.setValue(prettifyResult);
            } catch (err) {
                console.log(err.message);
            }
        },
    },
    created() {},
    computed: {
        codemirror() {
            return this.$refs.myCm.codemirror;
        },
        codemirrorvalue() {
            return this.value;
        },
    },
};
</script>

<style>
/*
.CodeMirror-focused .cm-matchhighlight {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAFklEQVQI12NgYGBgkKzc8x9CMDAwAAAmhwSbidEoSQAAAABJRU5ErkJggg==);
    background-position: bottom;
    background-repeat: repeat-x;
}
.cm-matchhighlight {
    background-color: lightgreen;
}
.CodeMirror-selection-highlight-scrollbar {
    background-color: green;
}
.CodeMirror {
    line-height: 21px;
}
*/
.CodeMirror-hints {
    z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/CodeEditorV2.vue